import React from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import WebhookKey from "../../components/Admin/profileComps/webhookApi"

const WebhookApikey = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Webhook API key | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <WebhookKey />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default WebhookApikey
